var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"rules":_vm.nameRules,"counter":_vm.computedCounter,"label":_vm.$t(_vm.label)},on:{"input":_vm.handleInput},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})}
var staticRenderFns = []

export { render, staticRenderFns }